import React from "react";
import {Link} from 'react-router-dom'

class Features extends React.Component {

    render() {
        return (
            <div className="container" id="up">
                <div className="features">
                    <div className="features__block">
                        <div className="feature">
                            <div className="feature__text-block">
                                <div className="feature__underscore">
                                </div>
                                <p className="feature__title"><b>SURVEY</b>STUDIO
                                </p>
                                <p className="feature__text">Сервис сбора, хранения и обработки маркетинговых,
                                    статистических и социологических данных.
                                </p>
                                <a className="feature__more" href="/surveystudio">Подробнее
                                    <img className="feature__arrow" src="images/arrow.svg"
                                         width="15" height="11" alt="" role="presentation"
                                    />
                                </a>
                                <img className="feature__pic" src="images/surveystudio.png"
                                     width="316" height="270" alt="" role="presentation"
                                />
                            </div>
                        </div>
                        <div className="feature">
                            <div className="feature__text-block">
                                <div className="feature__underscore">
                                </div>
                                <p className="feature__title">Dialer EXpress
                                </p>
                                <p className="feature__text">Система автоматизированного исходящего обзвона.
                                    Заставьте Ваших операторатов работать.
                                </p>
                                <a className="feature__more" href="/dex">Подробнее
                                    <img className="feature__arrow" src="images/arrow.svg"
                                         width="15" height="11" alt="" role="presentation"
                                    />
                                </a>
                                <img className="feature__pic" src="images/operators.png"
                                     width="201" height="215" alt="" role="presentation"
                                />
                            </div>
                        </div>
                        {/* <div className="feature">
                            <div className="feature__text-block">
                                <div className="feature__underscore">
                                </div>
                                <p className="feature__title">IP-ТЕЛЕФОНИЯ
                                </p>
                                <p className="feature__text">Проектирование контакт-центров и промышленных
                                    систем телефонии на базе Asterisk IP PBX.
                                </p>
                                <a className="feature__more" href="/ip">Подробнее
                                    <img className="feature__arrow" src="images/arrow.svg"
                                         width="15" height="11" alt="" role="presentation"
                                    />
                                </a>
                                <img className="feature__pic" src="images/ip.png"
                                     width="400" height="260" alt="" role="presentation"
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}

export default Features;


// WEBPACK FOOTER //
// ./src/Components/MainPage/Features.js